import template from './contactCompanyDetailsBox.template.html';

export default {
  template,
  bindings: {
    idTicket: '<',
    ticket: '<',
    owner: '<',
    contact: '=',
    loanAmount: '<',
    isEquifaxEnabled: '<',
    isIllionEnabled: '<',
    isDisabled: '<'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor(dateTimeService) {
      'ngInject';

      const ctrl = this;
      ctrl.showEquifax = false;
      ctrl.showIllion = false;
      ctrl.creditScoreObject = {};
      ctrl.creditScoreObjectEquifax = {};
      ctrl.creditScoreObjectIllion = {};
      ctrl.creditScore = 'N/A';
      ctrl.creditColor = 'grey-600';

      ctrl.initialize = () => {
        const creditScores = _.orderBy(
          _.filter(ctrl.ticket.integrationHistory, { name: 'CompanyExtractPlus' }),
          'timeStamp',
          'desc'
        );
        ctrl.creditScoreObject = _.head(creditScores) || {};
        const score = parseInt(ctrl.creditScoreObject?.timeStamp, 10);
        ctrl.creditScore = Number.isNaN(score)
          ? 'N/A'
          : dateTimeService.getFormattedDate(score);
        ctrl.creditColor = 'grey-600';
      };

      ctrl.onFinished = (idContact, creditScore) => {
        ctrl.showEquifax = false;
        ctrl.showIllion = false;
        if (idContact && creditScore && creditScore.length) {
          ctrl.ticket.integrationHistory = creditScore;
          ctrl.initialize();
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
